import { EscalationRequest, EscalationResponse, MyAccessResponse } from '../../../types';
import { createAuthenticatedApiClient } from '../../../shared/api/apiClient';
import { rpcCall } from '../../../shared/api/rpcClient';
import { useAuth } from '../../auth/context/AuthContext';
import { useMemo } from 'react';

export const createEscalationService = (idToken: string) => {
  const client = createAuthenticatedApiClient(idToken);

  return {
    requestEscalation: async (
      customerId: string,
      data: EscalationRequest
    ): Promise<EscalationResponse> => {
      return rpcCall(client, 'customers.RequestEscalation', {
        customer_id: customerId,
        ...data,
      });
    },

    listEscalations: async (customerId: string): Promise<EscalationResponse[]> => {
      return rpcCall(client, 'customers.ListEscalations', {
        customer_id: customerId,
      });
    },

    myAccess: async (customerId: string): Promise<MyAccessResponse> => {
      return rpcCall<MyAccessResponse>(client, 'customers.MyAccess', {
        customer_id: customerId,
      });
    },

    approveEscalation: async (
      customerId: string,
      userId: string
    ): Promise<EscalationResponse> => {
      return rpcCall(client, 'customers.ApproveEscalation', {
        customer_id: customerId,
        user_id: userId,
      });
    },

    revokeEscalation: async (customerId: string, userId: string): Promise<void> => {
      await rpcCall(client, 'customers.RevokeEscalation', {
        customer_id: customerId,
        user_id: userId,
      });
    },

    listPendingApprovals: async (): Promise<EscalationResponse[]> => {
      return rpcCall<EscalationResponse[]>(client, 'customers.ListPendingApprovals');
    },
  };
};

export const useEscalationService = () => {
  const { idToken } = useAuth();

  return useMemo(() => {
    if (!idToken) {
      throw new Error('Not authenticated');
    }

    return createEscalationService(idToken);
  }, [idToken]);
};
